import React from "react";
import { IS_LOGIN_VERIFICATION_ENABLED } from "../../helpers/constants";

import LoginRequestOTP from "./LoginRequestOTP";
import LoginLegacy from "./Login";

interface LogInProps {
  handleClosePanel?: () => void;
}

const LogIn = ({ handleClosePanel }: LogInProps) => {
  if (IS_LOGIN_VERIFICATION_ENABLED) {
    return <LoginRequestOTP handleClosePanel={handleClosePanel} />;
  }

  return <LoginLegacy handleClosePanel={handleClosePanel} />;
};

export default LogIn;
